export const GET_LAUNCHER_DATA = 'GET_LAUNCHER_DATA';
export const GET_USER_DATA = 'GET_USER_DATA';
export const UPDATE_USER_ACTIONS = 'UPDATE_USER_ACTIONS';
export const UPDATE_ACTIONS_DATA = 'UPDATE_ACTIONS_DATA';
export const GET_SKILLS_ACTION = 'GET_SKILLS_ACTION';
export const GET_RESET_DATA = 'GET_RESET_DATA';
